import { connect } from 'react-redux'
import { IStoreState } from '../../types'
import ServiceProgramList from '../../components/global-settings/ServiceProgramList'
import { fetchServicePrograms } from '../../state/actions/service-program/service-program'
import {
  getAllServicePrograms,
  getServiceProgramListFetching,
  getServiceProgramListFetchingError
} from '../../state/reducers/service-program/service-program'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  return {
    items: getAllServicePrograms(state),
    fetching: getServiceProgramListFetching(state),
    fetchingError: getServiceProgramListFetchingError(state),
    ...ownProps
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onComponentMount: () => {
      dispatch(fetchServicePrograms())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceProgramList)



// WEBPACK FOOTER //
// ./src/containers/service-program/ServiceProgramList.ts